import React from "react";
import { Skeleton } from "@/ui/Skeleton/Skeleton";
import cls from "./CompareSkeleton.module.scss";

/** Скелетон по геометрии живого экрана — F5 «Загрузка». */
export const CompareSkeleton = () => (
  <>
    <div className={cls.best}>
      <Skeleton width={150} height={11} radius={6} />
      <div className={cls.row}>
        <Skeleton width={36} height={36} radius={12} />
        <Skeleton width={70} height={14} radius={6} />
      </div>
      <Skeleton width={140} height={38} radius={8} />
      <Skeleton width={200} height={11} radius={6} />
    </div>
    <div className={cls.card}>
      <Skeleton width={80} height={16} radius={6} />
      <Skeleton height={132} radius={12} />
    </div>
    <div className={cls.card}>
      <Skeleton width={110} height={16} radius={6} />
      {[0, 1, 2].map((i) => (
        <Skeleton key={i} height={18} radius={6} />
      ))}
    </div>
  </>
);
